import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CrowdinOtaService } from 'src/app/services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-provider-page',
  templateUrl: './provider-page.component.html',
  styleUrls: ['./provider-page.component.scss']
})
export class ProviderPageComponent implements OnInit {
  isNotFound: boolean = false;
  _language: any;
  translationData: any;
  content: string = 'CP_PROVIDER_TEMPLATE';
  isTranslationDone: boolean = false;

  constructor(private readonly _translationService: TranslationService, 
    private readonly _actRoute: ActivatedRoute, 
    private readonly _crowdinService: CrowdinOtaService,
    private readonly languageService: LanguageService) { 
    const langId = this.languageService.getLanguage();
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
    this._language = langId && this.languageService.checkIsValideLanguage(langId) ? langId : 
    (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
      localStorage.setItem('language', this._language);
  }
  this._translationService.sharetranslationData.subscribe((data) => {
    this.translationData = data;
    this.isTranslationDone = true;
  });
  }

  ngOnInit(): void {
    this.content = 'CP_PROVIDER_TEMPLATE';

    const languageCode = this._language.split('-')[0];
    this._crowdinService.useLanguage(languageCode);
  }

}
